import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { resetAddButtonError } from '../../Reducer/StatusFlagsReducer';

const RouterContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(resetAddButtonError());
  }, [location.pathname]);

  return null;
};

export default RouterContainer;
